<template>
  <v-dialog v-model="modelLogin" width="700px" v-on:update:modelValue="fechar">
    <v-btn icon="mdi-close" size="x-small" class="btn-close" @click="fechar"></v-btn>
    <v-card>
      <v-card-text class="pa-0">
        <v-row class="position-relative ma-0">
          <v-col class="v-col-12 v-col-lg-7 d-flex align-between flex-wrap pa-6" v-if="newEmailForm">
            <div class="w-100 text-center">
              <h2 class="text-color-black">
                O seu cadastro não está autenticado
              </h2>
              <br>
              <span class="text-color-0">
                Vamos enviar um link de autenticação no seu E-mail.
              </span>
              <v-text-field variant="outlined" v-model="newEmail" label="Digite seu email" required class="mt-4"></v-text-field>
            </div>
            <div class="w-100 d-flex align-end flex-wrap mt-3">
              <v-row class="w-100">
                <v-col cols="6">
                  <v-btn variant="outlined" block size="x-large" class="text-color-2" @click="newEmailForm = false">Voltar</v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn :disabled="disabledLoading" variant="flat" block size="x-large" class="bg-color-2 text-color-white" @click="recuperarSenha()">Enviar</v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col class="v-col-12 v-col-lg-7 d-flex align-between flex-wrap pa-6" v-else>
            <div class="w-100">
              <h1 class="text-xhuge text-fine">FAÇA SEU<br>LOGIN</h1><br>
              <v-form ref="login" lazy-validation>
                <v-text-field variant="outlined" v-maska:[masks.cpf] v-model="user" label="Digite seu CPF/CNPJ" :rules="[rules.required]" data-cy="login-user"></v-text-field>
                <v-text-field class="mt-3" variant="outlined" v-model="password" label="Digite sua senha" :rules="[rules.required]" data-cy="login-pass" :type="showPassword ? 'text' : 'password'" :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:appendInner="showPassword = !showPassword"></v-text-field>
              </v-form>
              <a class="float-right cursor-pointer text-color-0 text-small" @click="recuperarSenha()">Esqueceu sua senha?</a>
            </div>
            <div class="w-100 d-flex align-end flex-wrap mt-3">
              <v-row class="w-100">
                <v-col cols="6">
                  <v-btn :disabled="disabledLoading" variant="outlined" block size="x-large" class="text-color-2" @click="$router.push('/register')">Cadastre-se</v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn :loading="disabledLoading" variant="flat" block size="x-large" class="bg-color-2 text-color-white cy-dialoglogin-entrar" @click="Login()">Entrar</v-btn>
                </v-col>
              </v-row>
              <div class="w-100 text-center text-small mt-2">
                <span class="text-color-black">
                  Ao cadastrar-se você concorda com nossos<br>
                  <a class="text-color-black text-decoration-none" :href="'https://ofertas.mobilesim.com.br/p/'+group+'.html'" target="_blank"><b>Termos e Política de Privacidade</b></a>
                </span>
              </div>
            </div>
          </v-col>
          <v-col class="d-none d-lg-flex justify-end v-col-5 pa-0">
            <img src="@/assets/images/modal-login.jpg" class="img-dialog">
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'DialogLogin',
  data(){
    return {
      group: import.meta.env.VITE_GROUP,
      showPassword: false,
      modelLogin: false,
      user: "",
      password: "",
      disabledLoading: false,
      masks: {
        cpf: {
          mask: (value) => value.length > 14 ? '**.***.***/####-##' : "***.***.**#-##",
        },
      },
      rules: {
        required: v => !!v || 'Este campo é obrigatório.',
      },
      newEmail: "",
      newEmailForm: false
    }
  },
  props: {
    model: {
      type: Boolean,
      default: false
    },
    fechar: {
      type: Function,
      default: null
    }
  },
  watch: {
    model() {
      this.modelLogin = this.model;
    }
  },
  methods: {
    ...mapActions('user', {
      userLogin: 'userLogin',
      passwordRecovery: 'passwordRecovery'
    }),
    removemask(value){
      return value.replaceAll(".", "").replaceAll(" ", "").replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll("/", "");
    },
    async Login(){
      const { valid } = await this.$refs.login.validate();
        if (valid){
        this.disabledLoading = true;
        this.userLogin({ "login": this.removemask(this.user), "password": this.password }).then((response) => {
          this.disabledLoading = false;
          if(response == true){
            this.fechar();
            this.$router.push('/');
          } else {
            this.emitter.emit('dialogMessage', { title: "Atenção!", message: response});
          }
        });
      }
    },
    recuperarSenha(){
      if(this.user != ''){
        let parametros = {
          "cpf": this.removemask(this.user)
        };
        if(this.newEmailForm == true && this.newEmail != ''){
          parametros.email = this.newEmail;
        }
        if(this.newEmailForm == true && this.newEmail == ''){
          this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Por favor, preencha corretamente o E-mail!"});
        } else {
          this.disabledLoading = true;
          this.passwordRecovery(parametros).then((response) => {
            this.disabledLoading = false;
            if (response.cod == 201) {
              if(response.error.data[0].status == 3){
                this.newEmailForm = true;
              } else {
                this.newEmailForm = false;
              }
              this.emitter.emit('dialogMessage', { title: "Atenção!", message: response.error.description[0] });
            } else {
              this.newEmailForm = false;
              this.emitter.emit('dialogMessage', { title: "Sucesso!", message: response.msg });
            }
          });
        }
      } else {
        this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Por favor, preencha corretamente o CPF/CNPJ para recuperar a senha!"});
      }
    }
  }
}
</script>